export default function isValidURL(url: string) {
  // Basic checks first
  if (!url || typeof url !== "string") {
    return false;
  }

  // Trim whitespace
  url = url.trim();

  // Must have at least one dot (for domain structure like example.com)
  if (!/.+\..+/.test(url)) {
    return false;
  }

  // Check for invalid characters in domain names
  // Domain names can only contain letters, numbers, hyphens, and dots
  // This will catch apostrophes and other invalid characters
  if (!/^[a-zA-Z0-9.-]+$/.test(url)) {
    return false;
  }

  // Additional checks for proper domain structure
  // - Cannot start or end with a dot or hyphen
  // - Cannot have consecutive dots
  // - Cannot have dots immediately before/after hyphens
  if (
    url.startsWith(".") ||
    url.endsWith(".") ||
    url.startsWith("-") ||
    url.endsWith("-") ||
    url.includes("..") ||
    url.includes(".-") ||
    url.includes("-.")
  ) {
    return false;
  }

  if (url !== encodeURI(url)) return false;

  return true;
}
